module.exports = __webpack_public_path__ + "img/privilege2.68ae2931.png";